import {
  ShowThisField,
  LabelInput,
  LabelTextArea,
  PageBreakAfterToggle,
  MobileVisible,
  LongTextMobileStyle,
  PlaceValueIn,
} from './shared'
import { useDispatch } from 'react-redux'
import { updateEntry } from 'apps/builder/store/actions/entries'
import { FancyCheckbox } from 'apps/builder/components/settings/modal'
import { Input } from 'components/Input/Input'
import { useDefaultValueNumberValidation } from 'apps/builder/lib/hooks/smartPreviewValidationHook'
import { FieldMaskSetting } from 'apps/builder/components/settings/modal/shared'
import { lib } from '@gocanvas/client'

const {
  SHORT_TEXT_ORIGINAL_TYPE_ID,
  LONG_TEXT_ORIGINAL_TYPE_ID
} = lib

export const TextMoreSettings = ({default: defaultValue, ...entry}) => {
  const dispatch = useDispatch()
  const { guid, original_type_id: string_type_id } = entry
  const minimum = 1
  const maximum = 255

  const original_type_id = parseInt(string_type_id, 10)

  const entryPDF = {
    showThisFieldType: 'pdf',
    ...entry,
  }

  const entryWeb = {
    showThisFieldType: 'web',
    ...entry,
  }

  const entryExport = {
    labelType: 'export',
    ...entry,
  }

  const entryReceipt = {
    labelType: 'receipt',
    ...entry,
  }

  const [isValid, errorText] = useDefaultValueNumberValidation({
    minimum,
    maximum,
    value: entry.length,
  })

  const updateMaxCharValue = value => {
    const length = String(value).replace(/[^0-9]/g, '').slice(0,3)
    dispatch(
      updateEntry({
        guid,
        length: length ? Number(length) : null,
      })
    )
  }
  const onKeyDown = e => {
    const key = e.key.toLowerCase()
    if (key === 'e' || key === '-' || key === '+') {
      e.preventDefault()
    }
  }

  const onBlur = e => {
    let convertedValue = Number(e.target.value.replace(/[^0-9]/g, ''))
    if (!Number.isNaN(convertedValue) && typeof convertedValue == 'number') {
      if (convertedValue > maximum) {
        convertedValue = maximum
      }
      updateMaxCharValue(convertedValue||'')
    }    
  }

  const TextType =
    original_type_id === LONG_TEXT_ORIGINAL_TYPE_ID ? (
      <PlaceValueInLongText {...entry} />
    ) : (
      <PlaceValueIn {...entry} />
    )
  return (
    <>
      {original_type_id === SHORT_TEXT_ORIGINAL_TYPE_ID && (
        <>
          <div className="settings--row no-border no-bottom">
            <div className="show-this-field-wrapper">
              <div className="settings--max-char-length">
                <Input { ... 
                        {
                          value: entry.length || undefined,
                          label: 'Max Character Length',
                          id: `${guid}-max-char`,
                          error: !isValid,
                          errorText: errorText,
                          update: updateMaxCharValue,
                          onBlur: onBlur,
                          onKeyDown: onKeyDown,
                          additionalClass: 'settings--inputs',
                          maxLength: 3,
                          type: 'number',
                          step: 1,
                          min: minimum,
                          max: maximum,
                        }
                      }
                />
              </div>
            </div>
          </div>
          <div className="settings--row no-border no-bottom">
            <div className="show-this-field-wrapper">
              <FieldMaskSetting {...entry} />
            </div>
          </div>
        </>
      )}
      {
        original_type_id === LONG_TEXT_ORIGINAL_TYPE_ID && (
          <div className="settings--row no-border no-bottom">
            <div className="show-this-field-wrapper">
              <label className="settings--label">Mobile Style</label>
              <LongTextMobileStyle {...entry} />
            </div>
          </div>
        )
      }
      <div className="settings--row no-border no-bottom">
        <div className="show-this-field-wrapper">
          <label className="settings--label">Visibility</label>
          <ShowThisField {...entryPDF} />
          <ShowThisField {...entryWeb} />
        </div>
        <div className="toggles-group">
          <div className="toggle-wrapper">
            <PageBreakAfterToggle {...entry} />
          </div>
          <div className="toggle-wrapper">
            <MobileVisible {...entry} />
          </div>
        </div>
      </div>

      <div className="settings--row no-top">
        <div className="show-this-field-wrapper">
          <label className="settings--label">Place value in:</label>
          {TextType}
        </div>
      </div>

      <label className="settings--label">Labels</label>
      <div className="checkbox-labels-wrapper">
        <LabelInput {...entryExport} />
        <LabelInput {...entryReceipt} />
      </div>
      <LabelTextArea {...entry} />
    </>
  )
}
const PlaceValueInLongText = ({ guid, auto_email_body }) => {
  const dispatch = useDispatch()
  return (
    <div className="place-value-in--checkboxes-wrapper show-this-field">
      <FancyCheckbox
        id={`${guid}--email-body`}
        checked={auto_email_body}
        onChange={() => {
          dispatch(
            updateEntry({
              guid,
              auto_email_body: auto_email_body ? false : true,
            })
          )
        }}
        label={'Email Body'}
      />
    </div>
  )
}
